import { FONT_PATH_URL } from '@alfa-bank/site-envconfig';

const getFontPathUrl = () => {
    try {
        return FONT_PATH_URL();
    } catch {
        return '//alfabank.st/media/about/fonts/fonts.css';
    }
};

export const FONT_PATH = getFontPathUrl();
